import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ConnectionQuality, NetworkService} from '../../services/network.service';

@Component({
    selector: 'app-connectivity-banner',
    templateUrl: './connectivity-banner.component.html',
    styleUrl: './connectivity-banner.component.scss'
})
export class ConnectivityBannerComponent implements OnInit, OnDestroy {

    online = true;
    quality: ConnectionQuality = 'unknown';

    private subscriptions = new Subscription();

    constructor(private networkService: NetworkService) {
    }

    ngOnInit() {
        this.subscriptions.add(this.networkService.online$.subscribe(online => this.online = online));
        this.subscriptions.add(this.networkService.quality$.subscribe(quality => this.quality = quality));
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
